import React, { FC, memo } from "react"
import {
  BannerStyled,
  ImgWrap,
  RootStyled,
  SubtitleStyled,
  TitleRedStyled,
  TitleStyled,
  WrapContent,
  WrapTextStyled,
} from "./styles"
import img1 from "./images/img4.webp"
import img2 from "./images/img2.webp"
import img3 from "./images/img3.webp"

export const DigitalAssistants: FC = memo(() => {
  return (
    <RootStyled id="digital">
      <WrapContent>
        <WrapTextStyled>
          <TitleStyled>
            AI-GENERATED&nbsp;
            <TitleRedStyled>DIGITAL ASSISTANTS</TitleRedStyled>
          </TitleStyled>
          <SubtitleStyled>
            Create an omnichannel user experience to improve customer
            satisfaction.
          </SubtitleStyled>
          <SubtitleStyled>
            Increase your sales and engage your clients with Avatars as AI
            Assistants.
          </SubtitleStyled>
        </WrapTextStyled>
        <ImgWrap>
          <BannerStyled src={img1} alt="" loading="lazy" />
          <BannerStyled src={img2} alt="" loading="lazy" />
          <BannerStyled src={img3} alt="" loading="lazy" />
        </ImgWrap>
      </WrapContent>
    </RootStyled>
  )
})
